export const fmtN = (n) => {
  if (n == null || isNaN(n)) return '0'
  return Number(n).toLocaleString('id-ID')
}

export const fmt = (n) => {
  if (n == null || isNaN(n)) return 'Rp 0'
  return 'Rp ' + fmtN(n)
}

export const fmtS = (n) => {
  n = Number(n)
  if (isNaN(n)) return 'Rp 0'
  if (n >= 1e9) return 'Rp ' + (n / 1e9).toFixed(1) + 'M'
  if (n >= 1e6) return 'Rp ' + (n / 1e6).toFixed(1) + 'Jt'
  return fmt(n)
}

export const pct = (a, b) => b ? Math.round(a / b * 100) : 0
export const today = () => new Date().toISOString().split('T')[0]

export const dateStr = (d) => {
  if (!d) return ''
  return new Date(d + 'T00:00:00').toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  })
}

export const pN = (s) => {
  if (typeof s === 'number') return s
  return parseInt(String(s).replace(/\D/g, ''), 10) || 0
}

export const fmtCoef = (n) => {
  if (!n) return '0'
  const s = Number(n)
  return s % 1 === 0 ? s.toString() : s.toFixed(4).replace(/0+$/, '').replace(/\.$/, '')
}

export const uid = () => {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 8)
}